import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

/**
 * This component is not meant to be used directly!
 * Use only with another wrapper card component.
 */
@Component({
  selector: 'mb-card-base',
  templateUrl: './card-base.component.html',
  styleUrls: ['./card-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardBaseComponent {
  @Input() wrapContent = true;
  @Input() sperateFooter = false;
  @ContentChild(TemplateRef, { static: false }) mediaTpl!: TemplateRef<any>;
}
